<template>
  <div class="newsletterForm">
    <validation-observer ref="form" slim>
      <validation-provider v-slot="{ errors }" rules="required|email">
        <form-input-with-button
          v-model="email"
          name="newsletter"
          theme="purple"
          :text="buttonText"
          mobile-text="+"
          placeholder="Twój adres email"
          class="newsletterForm__input"
          :small-padding="smallPaddingButton"
          @click="subscribe"
        />
        <span v-if="errors[0]" class="formField__error">{{ errors[0] }}</span>
      </validation-provider>
      <validation-provider
        v-slot="{ classes, errors }"
        :rules="{ required: { allowFalse: false } }"
      >
        <form-checkbox-simple
          name="agreement"
          :value="agreement"
          has-html
          small-error
          class="newsletterGrid__checkbox"
          :class="classes"
          @input="
            agreement === false
              ? pushModal({ modal: modalNewsletterAgreement })
              : resetResult(false)
          "
        >
          <span>Zgoda na przetwarzanie danych osobowych</span>
        </form-checkbox-simple>
        <span class="formField__error">{{ errors[0] }}</span>
      </validation-provider>
    </validation-observer>
    <div class="newsletterForm__info">
      <info-bar
        v-if="infoBarArray[0].isActive"
        :message="infoBarArray[0].message"
        :icon="infoBarArray[0].config.icon"
        :color="infoBarArray[0].config.color"
        small
        @close="hideInfoBar(0)"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import infoBarMixin from '~/mixins/infoBar';
import FormInputWithButton from '~/components/Form/FormInputWithButton';
import FormCheckboxSimple from '~/components/Form/FormCheckboxSimple';

export default {
  name: 'NewsletterForm',
  components: {
    FormCheckboxSimple,
    FormInputWithButton,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [infoBarMixin(1)],
  props: {
    buttonText: {
      type: String,
      default: 'Dołącz',
    },
    smallPaddingButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      email: '',
      agreement: false,
      modalNewsletterAgreement: {
        name: 'modalNewsletterAgreement',
        path: 'Newsletter/ModalNewsletterAgreement',
        title: 'Zgoda',
        buttons: [
          {
            action: 'acceptAgree',
            text: 'Wyrażam zgodę',
            theme: 'purple',
            space: 'none',
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      modalResult: state => state.modal.result,
      userEmail: state => state.auth.user.email,
    }),
  },
  watch: {
    modalResult(newValue) {
      this.agreement = newValue.value;
    },
  },
  created() {
    this.email = this.userEmail ? this.userEmail : null;
  },
  methods: {
    ...mapMutations({
      setResult: 'modal/setResult',
    }),
    ...mapMutations({
      pushModal: 'modal/pushModal',
    }),
    resetResult(val) {
      this.setResult({ type: 'error', value: val });
    },
    async subscribe() {
      if (await this.$refs.form.validate()) {
        let message = '';
        try {
          const formData = new FormData();
          formData.append('email', this.email);
          const { data } = await this.$axios.post(
            `${this.$config.baseOfixApi}/e-commerce/v1/users/confirmSubscription`,
            formData,
          );
          message = data.message;
          this.$refs.form.reset();
          this.email = '';
          this.agreement = false;
          this.setInfoBarConfig(0, this.successConfig);
        } catch (error) {
          if (error?.response?.data?.message) {
            message = error.response.data.message;
          } else {
            message = 'Wystąpił błąd';
          }
          this.setInfoBarConfig(0, this.errorConfig);
        } finally {
          this.setInfoBarMessage(0, message);
          this.showInfoBar(0);
        }
      }
    },
  },
};
</script>

<style lang="scss">
.newsletterForm {
  position: relative;

  &__info {
    position: absolute;
    top: calc(100% + 10px);
    left: 0;
    width: 100%;
  }

  &__input {
    width: 100%;
    margin-top: auto;
    margin-bottom: 0.5rem;
    border: 1px solid $cAddLight;
    border-radius: 4px;
  }
}
</style>
